import { Component, OnInit, ViewChild, EventEmitter, Output, Input, SimpleChanges, ElementRef, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { NgForm } from '@angular/forms';
import { ToastService } from '../service/toast.service';
import { Constants } from '../constants/constants';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { EnvService } from '../service/env.service';
import { PhoneValidatorDirective } from '../directives/phone-validator.directive';
import { PhoneFormatterDirective } from '../directives/phone-formatter.directive';
// import { Observable } from 'rxjs/internal/Observable';
// import { debounceTime } from 'rxjs/internal/operators/debounceTime';
// import { map } from 'rxjs/internal/operators/map';
// import { LanguagePreferenceComponent } from '../language-preference/language-preference.component';
// import { SearchCountryField, PhoneNumberFormat, CountryISO } from 'ngx-intl-tel-input';
// import { NgxIntlTelInputService } from '../service/ngx-intl-tel-input-service.service';
// import { PhoneNumberFormat } from 'google-libphonenumber';

@Component({
  selector: 'app-account-profile',
  templateUrl: './account-profile.component.html',
  styleUrls: ['./account-profile.component.scss']
})
export class AccountProfileComponent implements OnInit, AfterViewInit {

  @ViewChild('changePasswordForm') public changePasswordForm: NgForm;
  loggedInUser: any = {};
  status: Array<string> = ["Inactive", "Pending", "Active"];
  accountStatus: string = this.status[2];
  changePasswordModal: any = {};
  updateUserModal: any = {};
  isShowChangePasswordForm: boolean = false;
  isShowUpdateUserForm: boolean = false;
  passwordFormatError = Constants.PASSWORD_FORMAT_ERROR;
  isd;
  @Output() profileUpdatedEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() isPhoneNumberVerified;
  mfaSmsChargesMessage = Constants.MFA_SMS_CHARGES_MESSAGE;
  mfaTncLink = Constants.MFA_TNC_LINK;
  mfaUpdateButtonClickMessage = Constants.MFA_UPDATE_BUTTON_CLICK_MESSAGE;
  // currentPhoneNumber = null;
  // countryList: any[];
  account = this.apiService.accountDetail;

  // selectedCountryDetails: any;
  /* countryFormatter = (x: { name: string }) => x.name;
  searchCountry = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? []
        : this.countryList.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1))
    );

  selectedIsdDetails: any;
  isdFormatter = (x: { isd: string }) => x.isd;
  searchIsd = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? [] : this.countryList.filter(v => (v.name.toLowerCase().indexOf(term.toLowerCase()) > -1 || v.isd.toLowerCase().indexOf(term.toLowerCase()) > -1)))
    );
  phoneLength = 0; */

  allSupportedLanguages: any;
  localeLanguages: any;
  updatedPreferredLanguages: any;
  // SearchCountryField = SearchCountryField;
  // PhoneNumberFormat = PhoneNumberFormat;
  // selectedCountryISO: any;
  // selectedPhone: any;
	// preferredCountries: CountryISO[] = Constants.PREFERRED_COUNTRIES;

  @ViewChild('updateUserForm') public updateUserForm: NgForm;

  // countries = Constants.COUNTRIES;
  // selectedCountryIsd: String = null;
  // selectedUserPhone: String = null;

  adminPhone: string = null;
  adminCountryIsotwo: any;
  allCountryList: any[];
  
  // @ViewChild(PhoneValidatorDirective) phoneValidator!: PhoneValidatorDirective;
  // @ViewChild(PhoneFormatterDirective) phoneFormatter!: PhoneFormatterDirective;
  // @ViewChild('phoneElement', { static: false, read: ElementRef }) phoneInput!: ElementRef;
  
  // @ViewChild(PhoneValidatorDirective, { static: false }) phoneValidator!: PhoneValidatorDirective;
  // @ViewChild(PhoneFormatterDirective, { static: false }) phoneFormatter!: PhoneFormatterDirective;

  phoneInput!: ElementRef;
  phoneValidator: any;
  phoneFormatter: any;
  @ViewChildren('phoneElement', { read: ElementRef }) phoneInputs!: QueryList<ElementRef>;
  @ViewChildren(PhoneValidatorDirective) phoneValidators!: QueryList<PhoneValidatorDirective>;
  @ViewChildren(PhoneFormatterDirective) phoneFormatters!: QueryList<PhoneFormatterDirective>;

  constructor(private authService: AuthenticationService,
    private utilService: UtilService,
    private toastService: ToastService,
    private apiService: ApiService,
    private env: EnvService,
    private toast: ToastService,
    // private ngxIntlTelInputService: NgxIntlTelInputService
  ) {
      // this.countryList = this.utilService.getCountryList(this.env.REGION);
      this.allCountryList = this.utilService.getCountryList();
    // this.initDefaultCountry();
  }
  
  ngOnInit() {
    this.loggedInUser = this.authService.loggedInUser;
    
    this.localeLanguages = this.loggedInUser.preferences && this.loggedInUser.preferences.languagePreferences || null;
    this.getAllSupportedLanguages();
    // console.log("Logged in user  ", this.loggedInUser);

    this.initChangePasswordModal();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isPhoneNumberVerified) {
      this.loggedInUser.phoneNumberVerified = true;
    } else {
      this.loggedInUser.phoneNumberVerified = false;
    }
  }

  ngAfterViewInit(): void {
    this.initPhoneInputParams();
  }

  onAccountDeactivate() {
    this.accountStatus = this.status[0];
  }

  onActivate() {
    this.accountStatus = this.status[2];
  }

  onInviteResend() {
    // console.log("Resend invite request received.");
  }

  changePasswordFormSubmit(form: NgForm) {
    this.changePasswordForm = form;
    if (!form.valid) return;
    // console.log("change password modal::", this.changePasswordModal);
    if (this.changePasswordModal.password != this.changePasswordModal.confirmPassword) {
      this.toastService.showError("New password and confirm password do not match.");
      return;
    }
    if (this.changePasswordModal.password == this.changePasswordModal.oldPassword) {
      this.toastService.showError("New password should not be the same as old password.");
      return;
    }
    var payload = {
      "oldPassword": this.changePasswordModal.oldPassword,
      "password": this.changePasswordModal.password
    };
    this.utilService.showSpinner();
    this.authService.changePassword(payload).then((data) => {
      this.utilService.hideSpinner();
      // console.log("change password response data::", data);
      this.toastService.showSuccess(data.message);
      this.isShowChangePasswordForm = !this.isShowChangePasswordForm;
      this.initChangePasswordModal();
    }).catch((error) => {
      // console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          // console.log("refresh token api executed");
          this.changePasswordFormSubmit(form);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initChangePasswordModal() {
    if (this.changePasswordForm) {
      this.changePasswordForm.reset();
      this.changePasswordForm.resetForm();
    }
    setTimeout(() => {
      this.changePasswordModal = {
        oldPassword: null,
        password: null,
        confirmPassword: null
      }
    }, 500);
  }

  initUpdateUserModal() {
    this.updateUserModal = null;

    this.initUpdatedPreferredLanguages();

    /* let loggedInUserPhone = JSON.parse(JSON.stringify(this.loggedInUser.phoneNumber));
    if (loggedInUserPhone) {
      var isdPhone = this.utilService.splitIsdAndPhone(loggedInUserPhone);
      loggedInUserPhone = isdPhone.phone;
    } */

    this.updateUserModal = {
      name: this.loggedInUser.name,
      phone: this.utilService.checkPhoneWithIsd(this.loggedInUser.phoneNumber),
      isd: this.loggedInUser.isd ? this.loggedInUser.isd : Constants.DEFAULT_LOCALES[0].isd,
      country: this.loggedInUser.country ? this.loggedInUser.country : Constants.DEFAULT_LOCALES[0].country,
      // localeLanguages: this.updatedPreferredLanguages ? this.updatedPreferredLanguages.map(localeLanguage => localeLanguage.locale) : null
      localeLanguages: []
    };

    // console.log("this.loggedInUser: ", this.loggedInUser);
    // console.log("this.authService.loggedInUser: ", this.authService.loggedInUser);
    // console.log("this.updateUserModal: ", this.updateUserModal);
    // this.currentPhoneNumber = loggedInUserPhone;

    // this.selectedCountryIsd = this.updateUserModal.isd;
    // this.selectedUserPhone = this.updateUserModal.phone;
    
    this.adminCountryIsotwo = this.allCountryList.find(country => country.isd === this.updateUserModal.isd).isotwo;
    this.adminPhone = this.utilService.checkPhoneWithIsd(this.updateUserModal.phone);
    // this.triggerPhoneInputChange(this.adminPhone, this.adminCountryIsotwo);

    /* this.selectedCountryISO = this.ngxIntlTelInputService.getCountryISO(this.updateUserModal.country);
    this.selectedPhone = {
      "number": this.updateUserModal.phone
    }; */
    /* this.selectedPhone = {
      "number": this.updateUserModal.phone,
      // "countryCode": this.ngxIntlTelInputService.getCountryISO(this.updateUserModal.country),
      "countryCode": this.countryCode(this.updateUserModal.isd)
    }; */

    if (this.loggedInUser.multiFactorAuthentication == 'ENABLED') {
      this.updateUserModal.mfaPreference = this.loggedInUser.mfaPreference;
    }

    this.initDefaultCountry();
    
    /* if (this.masterSupportedLanguages) {
      if (this.loggedInUser &&
        this.loggedInUser.preferences &&
        this.loggedInUser.preferences.languagePreferences &&
        this.loggedInUser.preferences.languagePreferences.length) {
        this.masterSupportedLanguages.forEach((masterSupportedLanguage: any) => { masterSupportedLanguage.isChecked = (this.loggedInUser.preferences.languagePreferences[0].language == masterSupportedLanguage.language) });
      } else {
        this.masterSupportedLanguages.forEach((masterSupportedLanguage: any) => { masterSupportedLanguage.isChecked = (masterSupportedLanguage.locale == 'es_ES') });
      }
    } else {
      this.masterSupportedLanguages = [];
    } */

  }

  updateUserFormSubmit(form: NgForm) {
    if (!form.valid) return;
    // console.log("update user modal::", this.updateUserModal);
    // this.isd = this.selectedIsdDetails.isd;
    // this.updateUserModal.country = this.selectedCountryDetails.name;
    
    // this.updateUserModal.phone = this.selectedPhone && this.ngxIntlTelInputService.removeNonNumeric(this.selectedPhone.number) || null;
    
    // this.updateUserModal.isd = this.selectedCountryIsd;
    // this.updateUserModal.phone = this.selectedUserPhone;

    this.updateUserModal.isd = this.allCountryList.find(country => country.isotwo === this.adminCountryIsotwo).isd;
    this.updateUserModal.phone = this.adminPhone.replace(/\D/g, '');  

    var payload = this.getUpdateUserModalPayload();
    this.utilService.showSpinner();
    this.apiService.updateUserProfile(payload, this.loggedInUser.userId).then((data) => {
      this.utilService.hideSpinner();
      this.toastService.showSuccess(data.message);
      // Update local data for user details too
      this.loggedInUser.name = payload.name;
      this.loggedInUser.phoneNumber = payload.phone;
      this.loggedInUser.isd = payload.isd;
      this.loggedInUser.country = payload.country;
      // console.log("loggedin user: ", this.loggedInUser);
      if (this.loggedInUser.multiFactorAuthentication == 'ENABLED') {
        this.loggedInUser.mfaPreference = payload.mfaPreference;
      }  

      this.resetUpdateUserModel();
      this.profileUpdatedEmitter.emit();
    }).catch((error) => {
      // console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          // console.log("refresh token api executed");
          this.updateUserFormSubmit(form);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetChangePasswordModel() {
    this.isShowChangePasswordForm = false;
    this.initChangePasswordModal();
  }

  resetUpdateUserModel() {
    this.isShowUpdateUserForm = false;

    if (this.updateUserForm) {
      this.updateUserForm.reset();
      this.updateUserForm.resetForm();
    }

    setTimeout(() => {
      this.initUpdateUserModal();
    }, 500);
  }

  resetModels() {
    // console.log("reset models");
    this.resetChangePasswordModel();
    this.resetUpdateUserModel();
  }

  getUpdateUserModalPayload() {
    let payload = JSON.parse(JSON.stringify(this.updateUserModal));

    if (![null, ""].includes(payload.phone)) {
      payload.phone = payload.phone;
      payload.isd = payload.isd;
    }
    
    delete payload.country;  

    return payload;
  }

  verifyProfile() {
    this.profileUpdatedEmitter.emit();
  }

  /* isdSelected(isd) {
  }

  countrySelected(country) {
    let selectedCountryDetail = this.countryList.filter(countryObject => countryObject.name == this.updateUserModal.country)[0];
    this.isd = selectedCountryDetail ? selectedCountryDetail.isd : null;
  } */

  initDefaultCountry() {
    // console.log("--- accounts: ", this.account);
    // console.log("--- loggedinuser: ", this.loggedInUser);
    // this.selectedCountryDetails = this.countryList.filter(country => country.name == this.loggedInUser.country)[0];
    // this.selectedIsdDetails = this.countryList.filter(country => country.isd == this.loggedInUser.isd)[0];
    // this.phoneLength = this.selectedIsdDetails ? this.selectedIsdDetails.phoneLength : 0;
    // console.log("selectedCountryDetails: ", this.selectedCountryDetails);
    // // console.log("selectedIsdDetails: ", this.selectedIsdDetails);
  }

  onCountrySelected(event) {
    // console.log("selected country: ", event.item);
  }

  onIsdSelected(event) {
    // this.phoneLength = event.item.phoneLength;
  }

  onLanguageSelected(checked: boolean, index: any) {
    this.allSupportedLanguages[index].ischecked = checked;
    this.updatedPreferredLanguages = this.allSupportedLanguages.filter(language => language.ischecked);
    this.updateUserModal.localeLanguages = this.updatedPreferredLanguages.map(localeLanguage => localeLanguage.locale);
  }

  getAllSupportedLanguages() {
    this.utilService.showSpinner();
    this.apiService.getAllSupportedLanguages().then((data) => {
      this.utilService.hideSpinner();
      this.allSupportedLanguages = data;
      // console.log("All supported languages::", this.allSupportedLanguages);
      this.initUpdateUserModal();
    }).catch((error) => {
      // console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          // console.log("refresh token api executed");
          this.getAllSupportedLanguages();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initUpdatedPreferredLanguages() {
    let preferredLocales;
    if (this.localeLanguages) {
      this.updatedPreferredLanguages = JSON.parse(JSON.stringify(this.localeLanguages));
      preferredLocales = this.updatedPreferredLanguages.map(localeLanguage => localeLanguage.locale);
    }

    this.allSupportedLanguages.forEach(language => {
      language["ischecked"] = preferredLocales ? preferredLocales.includes(language.locale) : null
    });
  }

  onCountryChange(event: any) {
    // this.updateUserModal.country = this.ngxIntlTelInputService.getCountryName(event.name);
    this.updateUserModal.isd = "+" + event.dialCode;
  }

  countryCode(isd: string) {
    if (!isd) {
      // console.log("ISD not set. Setting it to default");
      isd = Constants.DEFAULT_LOCALES[0].isd;
    }
    let countryCode;
    // let countryData = this.ngxIntlTelInputService.filterCountriesByIsd(isd);
    // if (countryData && countryData.length > 1) {
    //   countryCode = countryData[1];
    // }
    return countryCode;
  }  
  
  countryUpdated(event: any) {
    this.triggerPhoneInputChange(this.adminPhone, event);
  }

  triggerPhoneInputChange(phone: string, isotwo: string) {
    if (this.phoneValidator) {
      this.phoneValidator.countryCode = isotwo;
    }
    
    if (this.phoneFormatter) {
      this.phoneFormatter.countryCode = isotwo;
    }
    
    if (this.phoneInput) {
      this.phoneInput.nativeElement.value = phone;
      
      // force Angular to notice the change
      const event = new Event('input', { bubbles: true });
      this.phoneInput.nativeElement.dispatchEvent(event);
    }
    
    // ✅ ensure validation runs again
    const ngModelControl = (this.phoneInput as any)?._ngModel?.control;
    if (ngModelControl) {
      ngModelControl.updateValueAndValidity();
    }
  }

  getadminCountryIsotwoIsd() {
    let adminCountryIsotwoData = this.allCountryList.find(country => country.isotwo === this.adminCountryIsotwo);
    return adminCountryIsotwoData ? adminCountryIsotwoData.isd : null;
  }

  onUpdateProfile() {
    setTimeout(() => {
      this.initPhoneInputParams();
    }, 0);
  }

  initPhoneInputParams() {
    this.phoneInputs.changes.subscribe((list: QueryList<ElementRef>) => {
      this.phoneInput = list.first;
    });
    
    this.phoneValidators.changes.subscribe((list: QueryList<PhoneValidatorDirective>) => {
      this.phoneValidator = list.toArray()[0];
    });

    this.phoneFormatters.changes.subscribe((list: QueryList<PhoneFormatterDirective>) => {
      this.phoneFormatter = list.toArray()[0];
    });

    if (this.phoneInput && this.phoneValidator && this.phoneFormatter) {
      this.triggerPhoneInputChange(this.adminPhone, this.adminCountryIsotwo);
    }
  }
}